import { mutatorAction } from 'satcheljs';
import { getStore, getCopilotChatDrawerState, getInitialState } from '../store/store';

/**
 * Updates the appCanvasWidth for the given window.
 *
 * This function also creates the state for the window if it doesn't exist,
 * as setting the appCanvasWidth can be called before a drawer is open.
 */
export const setAppCanvasWidthMutator: (targetWindow: Window, width: number) => void =
    mutatorAction('setAppCanvasWidthMutator', (targetWindow: Window, width: number): void => {
        const state = getCopilotChatDrawerState(targetWindow);
        if (state) {
            state.appCanvasWidth = width;
        } else {
            // Initialize initial instance of this state for this target window
            const newState = getInitialState();
            newState.appCanvasWidth = width;
            getStore().chatDrawerStateMap.set(targetWindow, newState);
        }
    });
